import Main from './main/Index.vue'
import Lk from './lk/Index.vue'
import About from './about/Index.vue'
import Cart from './cart/Index.vue'
import Login from './login/Index.vue'
import Order from './orders/order/Index.vue'
import ListOrders from './orders/listOrders/Index.vue'
import Payment from './orders/payment/Index.vue'
import Favorites from './favorites/Index.vue'
import Sale from './sale/Index.vue'
import NotFound from './errors/NotFound.vue'
import FatalError from './errors/FatalError.vue'
import AccessDenied from './errors/AccessDenied.vue'
import Services from './services'
import MyAgency from './myAgency/Index.vue'
import Events from './events/Index.vue'
import Contacts from './contacts/Index.vue'

export default {
  Main,
  Lk,
  About,
  Cart,
  Login,
  Order,
  Favorites,
  Sale,
  NotFound,
  FatalError,
  AccessDenied,
  Services,
  MyAgency,
  Events,
  ListOrders,
  Contacts,
  Payment
}
